import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { provinceFetch, selectLicenseList } from "./Body/api/redux";
import Body from "./Body/Body";
import Header from "./Header/Header";

export default () => {
  const dispatch = useDispatch()
  const state = useSelector(selectLicenseList)

 

  return (
    <div className="d-flex flex-column ">
      <Header />
      <Body />
    </div>
  );
};
